import React from 'react';
import LegalDoc from './LegalDoc';
// Vite imports the .md file as a raw string at build time (works with
// vite-react-ssg — the content is baked into the static HTML).
// Adjust the path if you place the .md files somewhere other than next to
// this component.
import content from './MASTER_SERVICES_AGREEMENT.md?raw';

const MasterServicesAgreement = () => <LegalDoc content={content} />;

export default MasterServicesAgreement;
